import React from "react";

import { cn } from "src/utils/cn";
import { useSidebar } from "src/contexts/SidebarContext";
import { useAuth } from "src/contexts/AuthContext";
import { SidebarNav } from "src/components/sidebar/SidebarNav";
import { SidebarWorkspaceSwitcher } from "src/components/sidebar/SidebarWorkspaceSwitcher";
import { SidebarSearchTrigger } from "src/components/sidebar/SidebarSearchTrigger";
import { SidebarFooter } from "src/components/sidebar/SidebarFooter";
import { NAV_CONFIG } from "src/config/navigation";

// Filters nav items by account type and resource permissions.
function navForUser(items, accountType, can) {
  return items.filter((item) => {
    if (item.developerOnly && accountType !== "developer") return false;
    if (item.brokerOnly && accountType !== "broker") return false;
    if (item.requires && !can(item.requires.resource, item.requires.action)) return false;
    return true;
  });
}

/* ── Sidebar shell ──────────────────────────────────────────────────────────── */
export function Sidebar({ className }) {
  const { collapsed } = useSidebar();
  const { currentUser, can } = useAuth();
  const sidebarWidth = collapsed ? 64 : 192;
  const navItems = navForUser(NAV_CONFIG, currentUser?.account_type, can);

  return (
    <aside
      className={cn(
        "group/sidebar flex h-full shrink-0 flex-col bg-gray-50 p-1 transition-all duration-200",
        collapsed ? "w-16" : "w-48",
        className
      )}
      style={{
        width: `${sidebarWidth}px`,
        minWidth: `${sidebarWidth}px`,
        maxWidth: `${sidebarWidth}px`,
      }}
    >
      <SidebarWorkspaceSwitcher />
      <div className="mt-3">
        <SidebarSearchTrigger />
      </div>
      <SidebarNav items={navItems} />
      <div className="mt-auto pt-2">
        <SidebarFooter />
      </div>
    </aside>
  );
}

